import { TweenMax } from 'gsap';
import Core from '../../Core/Core';
import { createOutlineText } from '../../Utils/Utils';
import { buttonIdleAnimation } from '../Animations/UIAnimations';
import Rectangle = PIXI.Rectangle;
import { UIButton } from '../Shared/Buttons/UIButton';
import { ScrollView } from '../Shared/ScrollView/ScrollView';

export default class MapGateList extends PIXI.Sprite {
    private btns: UIButton[];
    private trigger: (id: string) => void;
    private scrollView: ScrollView;

    constructor(list: string[], trigger: (id: string) => void, width: number, height: number) {
        super();
        this.scrollView = new ScrollView(width, height, this, false, true);
        const spc = 10;
        this.btns = list.map((mapId, i) => {
            const btnId = 'mapui/' + mapId + '-gate-tab';
            const btn = new UIButton(btnId);
            btn.bg.anchor.y = 0;
            btn.x = btn.width / 2;
            btn.y = btn.height * 0.25 + (spc + btn.height) * i;
            const text = createOutlineText(
                Core.local.getText(mapId),
                new Rectangle(0, 0, btn.width * 0.8, btn.height * 0.4),
                'Baloo',
                40,
                35,
                0xffffff,
                0x470e18,
                3
            );
            text.anchor.set(0.5, 1.3);
            text.y = btn.height;
            btn.addChild(text);
            btn.alpha = 0.5;
            btn.once('trigger', () => {
                this.trigger(mapId);
            });

            return btn;
        });

        this.trigger = trigger;

        this.btns.forEach(element => {
            this.scrollView.addItem(element);
        });

        this.btns.forEach(element => {
            element.scale.set(0.9);
        });
    }

    public removeListeners() {
        this.btns.forEach((element, index) => {
            element.removeAllListeners();
        });
    }

    public tweenIn(newAddition: boolean = false) {
        [...this.btns].forEach((element, index) => {
            TweenMax.to(element, 0.1, { delay: 0.1 * (index + 1), alpha: 1 });
            TweenMax.to(element.scale, 0.2, {
                x: 1,
                y: 1,
                delay: 0.1 * (index + 1),
                onComplete: () => {
                    if (newAddition && index === this.btns.length - 1) {
                        buttonIdleAnimation(element as UIButton, 1);
                    }
                },
            });
        });
    }
}
